import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import admin from './modules/admin';
import auth from './modules/auth';
import category from './modules/category';
import rallyCategory from './modules/rallyCategory';
import userSegment from './modules/userSegment';
import company from './modules/company';
import connection from './modules/connection';
import event from './modules/event';
import hobby from './modules/hobby';
import interest from './modules/interest';
import moderator from './modules/moderator';
import rally from './modules/rally';
import special from './modules/special';
import stripe from './modules/stripe';
import tag from './modules/tag';
import dealTemplate from './modules/dealTemplate';
import dealImagePromptTemplate from './modules/dealImagePromptTemplate';
import user from './modules/user';
import review from './modules/review';
import supportInbox from './modules/supportInbox';
import { PERSISTED_STATE_PATHS } from './persistedStatePaths';

const persistedStatePlugin = createPersistedState({
  paths: PERSISTED_STATE_PATHS,
});

const store = createStore({
  plugins: [persistedStatePlugin],
  modules: {
    admin,
    auth,
    category,
    rallyCategory,
    userSegment,
    company,
    connection,
    event,
    hobby,
    interest,
    moderator,
    rally,
    special,
    stripe,
    tag,
    dealTemplate,
    dealImagePromptTemplate,
    user,
    review,
    supportInbox,
  },
  strict: import.meta.env.DEV,
});

export default store;
